export default __webpack_public_path__ + "static/logo-invictus-9d3d68805c5a013068c1677fe89313b5.webp";